/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectActivity} from '../api'

export const useMutationSelectActivity = createReactQueryMutationHook('selectActivity', selectActivity)
